import { Alert, Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { useSampleSet } from '../../../../../../contexts/SampleSetContext';
import { ResultType } from '../../../../../../enums';
import HydraDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/hydra/HydraDifferentialAnalysisTab';
import IdDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdDifferentialAnalysisTab';
import IdParquetDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/id/IdParquetDifferentialAnalysisTab';
import MwmineFeaturesDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/mwmineFeatures/MwmineFeaturesDifferentialAnalysisTab';
import PeptidesDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/peptides/PeptidesDifferentialAnalysisTab';
import QuantDifferentialAnalysisTab from '../../../../../../pages/experiments/resultsAnalysis/quant/QuantDifferentialAnalysisTab';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/_toolbar/differential-analysis'
)({
  staticData: { ddViewName: 'experiments-differential-analysis-tab' },
  component: DifferentialAnalysisRouteComponent,
});

function DifferentialAnalysisRouteComponent() {
  const { selectedJob, selectedJobId, jobs } = useSampleSet();

  const showAlert = !selectedJobId && jobs.length > 0;

  let DifferentialAnalysisTab;
  switch (selectedJob?.result_type) {
    case ResultType.ID_PARQUET:
      DifferentialAnalysisTab = IdParquetDifferentialAnalysisTab;
      break;
    case ResultType.ID:
      DifferentialAnalysisTab = IdDifferentialAnalysisTab;
      break;
    case ResultType.HYDRA:
      DifferentialAnalysisTab = HydraDifferentialAnalysisTab;
      break;
    case ResultType.PEPTIDES:
      DifferentialAnalysisTab = PeptidesDifferentialAnalysisTab;
      break;
    case ResultType.MWMINE_FEATURES:
      DifferentialAnalysisTab = MwmineFeaturesDifferentialAnalysisTab;
      break;
    default:
      DifferentialAnalysisTab = QuantDifferentialAnalysisTab;
  }

  return (
    <>
      {showAlert && (
        <Box sx={{ mx: 2, mt: 1 }}>
          <Alert severity="info" sx={{ mb: 1 }}>
            Please select an inference run to view differential analysis results
          </Alert>
        </Box>
      )}
      {selectedJobId && <DifferentialAnalysisTab />}
    </>
  );
}
